const { createSlice } = require("@reduxjs/toolkit");

const initialState = {
  savedAddressesErrorMessage: "",
  savedAddresses: [],
  isSavedAddressesLoading: false,
  hasSavedAddressesFetched: false,
};

const SavedAddressesSlice = createSlice({
  name: "SavedAddressesSlice",
  initialState,
  reducers: {
    /**
     * Reducer to fetch the saved addresses.
     * @param {Object} state - Current state.
     */
    requestToSavedAddress: (state, action) => {
      if (state.isSavedAddressesLoading) {
        return state;
      }

      if (state.hasSavedAddressesFetched && !action.payload?.force) {
        return state;
      }

      return {
        ...state,
        isSavedAddressesLoading: true,
      };
    },
    /**
     * Reducer to updated error Messages.
     * @param {Object} state - Current state.
     * @param {string} action.payload - Error message related to OTP verification.
     */
    savedAddressError: (state, action) => {
      return {
        ...state,
        savedAddressesErrorMessage: action.payload,
        isSavedAddressesLoading: false,
        hasSavedAddressesFetched: true,
      };
    },
    /**
     * Reducer to updated saved Addresses.
     * @param {Object} state - Current state.
     * @param {string} action.payload - Error message related to OTP verification.
     */
    setSavedAddress: (state, action) => {
      return {
        ...state,
        savedAddresses: Array.isArray(action.payload) ? action.payload : [],
        isSavedAddressesLoading: false,
        hasSavedAddressesFetched: true,
      };
    },
  },
});
export default SavedAddressesSlice.reducer;
export const { requestToSavedAddress, savedAddressError, setSavedAddress } = SavedAddressesSlice.actions;
